<template>
  <div>
    <main-header />
    <div class="daily-cargo-edit-rac-number">
      <div class="daily-cargo-edit-rac-number__references" />
      <div class="daily-cargo-edit-rac-number__dgr_references">
        <div style="grid-column: 1; grid-row: 1;">
          <form-label>RAC Register Nr.</form-label>
          <form-input
            v-model="dailyCargoDriverData.RAC_Register_Nr"
            :invalid="$v.dailyCargoDriverData.RAC_Register_Nr && $v.dailyCargoDriverData.RAC_Register_Nr.$invalid"
            placeholder="RAC Register Nr."
            data-cy="edit-daily-cargo-rac-register" />
          <span v-if="$v.dailyCargoDriverData.RAC_Register_Nr && !$v.dailyCargoDriverData.RAC_Register_Nr.$invalid" class="error">Please enter a RAC Register Nr</span>
        </div>
        <div style="grid-column: 2; grid-row: 1;">
          <form-label>Rac Name</form-label>
          <form-input
            v-model="dailyCargoDriverData.RAC_Name"
            :invalid="$v.dailyCargoDriverData.RAC_Name && $v.dailyCargoDriverData.RAC_Name.$invalid"
            placeholder="Rac Name"
            data-cy="edit-daily-cargo-rac-name" />
          <span v-if="$v.dailyCargoDriverData.RAC_Name && !$v.dailyCargoDriverData.RAC_Name.$invalid" class="error">Please enter a RAC Name</span>
        </div>
        <div style="grid-column: 3; grid-row: 1;">
          <form-label>RAC Status</form-label>
          <form-input
            v-model="dailyCargoDriverData.RAC_Status"
            :invalid="$v.dailyCargoDriverData.RAC_Status && $v.dailyCargoDriverData.RAC_Status.$invalid"
            placeholder="RAC Status"
            data-cy="edit-daily-cargo-rac-status" />
          <span v-if="$v.dailyCargoDriverData.RAC_Status && !$v.dailyCargoDriverData.RAC_Status.$invalid" class="error">Please enter a RAC Status</span>
        </div>
        <div style="grid-column: 1; grid-row: 2;">
          <form-label>Rac Address</form-label>
          <form-input
            v-model="dailyCargoDriverData.RAC_Address"
            :invalid="$v.dailyCargoDriverData.RAC_Address && $v.dailyCargoDriverData.RAC_Address.$invalid"
            placeholder="Rac Address"
            data-cy="edit-daily-cargo-rac-address" />
          <span v-if="$v.dailyCargoDriverData.RAC_Address && !$v.dailyCargoDriverData.RAC_Address.$invalid" class="error">Please enter a RAC Address</span>
        </div>
        <div style="grid-column: 2; grid-row: 2;">
          <form-label>RAC Postal Code</form-label>
          <form-input
            v-model="dailyCargoDriverData.RAC_Zip_Code"
            :invalid="$v.dailyCargoDriverData.RAC_Zip_Code && $v.dailyCargoDriverData.RAC_Zip_Code.$invalid"
            placeholder="RAC Postal Code"
            data-cy="edit-daily-cargo-zip-code" />
          <span v-if="$v.dailyCargoDriverData.RAC_Zip_Code && !$v.dailyCargoDriverData.RAC_Zip_Code.$invalid" class="error">Please enter a RAC Postal Code</span>
        </div>
        <div style="grid-column: 3; grid-row: 2;">
          <form-label>Rac City</form-label>
          <form-input
            v-model="dailyCargoDriverData.RAC_City"
            :invalid="$v.dailyCargoDriverData.RAC_City && $v.dailyCargoDriverData.RAC_City.$invalid"
            placeholder="Rac City"
            data-cy="edit-daily-cargo-rac-city" />
          <span v-if="$v.dailyCargoDriverData.RAC_City && !$v.dailyCargoDriverData.RAC_City.$invalid" class="error">Please enter a RAC City</span>
        </div>
        <div style="grid-column: 4; grid-row: 2;">
          <form-label>RAC Country</form-label>
          <form-input
            v-model="dailyCargoDriverData.RAC_Country"
            :invalid="$v.dailyCargoDriverData.RAC_Country && $v.dailyCargoDriverData.RAC_Country.$invalid"
            placeholder="RAC Country"
            data-cy="edit-daily-cargo-rac-country" />
          <span v-if="$v.dailyCargoDriverData.RAC_Country && !$v.dailyCargoDriverData.RAC_Country.$invalid" class="error">Please enter a RAC Country</span>
        </div>
      </div>
    </div>
    <daily-cargo-edit-action-bar
      :invalid="$v.$invalid"
      @onSave="handleSave"
      @onCancel="handleCancel" />
  </div>
</template>
<script>
import MessageDialog from '@/components/shared/message-dialog'
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { create } from 'vue-modal-dialogs'
import Helpers from '@/helpers.vue'
import constants from '@/constants'
const messageDialog = create(MessageDialog, 'content')

export default {
  mixins: [Helpers],
  data () {
    return {
      routeLabel: '',
      dailyCargoDriverData: {},
      constants
    }
  },
  validations () {
    return {
      dailyCargoDriverData: {
        ...this.validatedFields
      }
    }
  },
  computed: {
    validatedFields () {
      var fields = {}
      if (!this.dailyCargoDriverData.RAC_Register_Nr) {
        fields.RAC_Register_Nr = { required }
      }
      if (!this.dailyCargoDriverData.RAC_Name) {
        fields.RAC_Name = { required }
      }
      if (!this.dailyCargoDriverData.RAC_Address) {
        fields.RAC_Address = { required }
      }
      if (!this.dailyCargoDriverData.RAC_Zip_Code) {
        fields.RAC_Zip_Code = { required }
      }
      if (!this.dailyCargoDriverData.RAC_City) {
        fields.RAC_City = { required }
      }
      if (!this.dailyCargoDriverData.RAC_Country) {
        fields.RAC_Country = { required }
      }
      if (!this.dailyCargoDriverData.RAC_Status) {
        fields.RAC_Status = { required }
      }
      return fields
    }
  },
  created () {
    this.dailyCargoDriverData = this.$route.params
  },
  methods: {
    ...mapActions('dailyCargo', ['saveDailyCargoRACNumber']),
    getRouteLabel (flightId) {
      return this.routeOptions.filter(route => route.value === flightId)[0].label
    },
    validateAndSend () {
      this.isLoading = true
      this.saveDailyCargoRACNumber(this.dailyCargoDriverData).then((response) => {
        this.isLoading = false
        this.$router.push('/daily-cargo-general/1')
        this.$forceUpdate()
      }).catch((error) => {
        this.isLoading = false
        messageDialog('Something went wrong: ' + error.ExceptionMessage)
      })
    },
    // *********************** Handle Actionbar *************************
    handleSave () {
      this.validateAndSend()
    },
    handleCancel () {
      this.$router.push('/daily-cargo-general/1')
    }
  }
}
</script>
<style lang="scss">
  @import '../../../variables.scss';
  .daily-cargo-edit-rac-number {
    margin-bottom: 100px;
    margin: 0 70px;
    width: calc(100% - 138px);

    &__dgr_references {
      display: grid;
      grid-template-columns: 24% 24% 24% 24%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 50px;
    }
  }
</style>
